import ServiceRequestLayout from '@/components/public/services/ServiceRequestLayout';

export default function Maintenance() {
  return (
    <ServiceRequestLayout
      seoTitle="Manutenção"
      seoDescription="Detetou um problema na via pública, iluminação, espaços verdes ou outro equipamento da freguesia? Comunique-nos e tratamos do resto."
      badge="Serviços ao Cidadão"
      breadcrumbs={[{ label: 'Serviços', href: '/services' }, { label: 'Comunicar ocorrência' }]}
      title="Manutenção"
      accentWord="Manutenção"
      subtitle="Detetou um problema na via pública, iluminação, espaços verdes ou outro equipamento da freguesia? Comunique-nos e tratamos do resto."
      panelTitle="Comunicar ocorrência"
      panelIntro="A identificação é opcional. Se fornecer contacto, poderemos contactá-lo para esclarecimentos ou para comunicar o encaminhamento da ocorrência."
      requiredNote={false}
    >
      <div className="border-line text-on-surface-light rounded-lg border-2 border-dashed p-8 text-center">
        <p>Formulário em breve disponível.</p>
      </div>
    </ServiceRequestLayout>
  );
}
